import { AxiosRequestConfig, AxiosResponse } from 'axios'
import api, { errorHandling } from '../http/api'
import { VerificaAuthData } from './AuthenticateResponse'
import { setCertification } from '../../modules/login/sessionSlice'
import ENV from '../env'

const AUTH_BASE_ENDPOINT = '/session/verifica/'

interface Authentication {
	code: string
}

const post = async (
	username: string,
	password: string
): Promise<VerificaAuthData> => {
	const authenticationData = {
		username,
		password
	}

	const requestConfig: AxiosRequestConfig = {
		baseURL: ENV.API_AUTHENTICATION
	}

	return api
		.post<Authentication, AxiosResponse<VerificaAuthData>>(
			AUTH_BASE_ENDPOINT,
			authenticationData,
			requestConfig
		)
		.then((response: any) => {
			if (response.data?.error) {
				throw new Error('Erro inesperado')
			}

			if (response.data?.status && response.data?.status === 400) {
				throw new Error('Código incorreto')
			}

			setCertification(response.data.access_token)
			return response.data
		})
		.catch(errorHandling)
}

export const authenticationApi = {
	post
}
